<template>
    <FciDialog :title="this.$f.tc('setting')" :width="1000" v-model="show">
        <div class="Setting">
            <v-tabs v-model="tab" grow>
                <v-tab>
                    <v-icon class="mr-1">mdi-memory</v-icon>
                    {{ $f.tc('variable') }}
                </v-tab>
                <v-tab>
                    <v-icon class="mr-1">mdi-lumx</v-icon>
                    {{ $f.tc('constant') }}
                </v-tab>
                <v-tab>
                    <v-icon class="mr-1">mdi-tag</v-icon>
                    {{ $f.tc('tag') }}
                </v-tab>
                <v-tab>
                    <v-icon class="mr-1">mdi-open-in-app</v-icon>
                    {{ $f.tc('webview') }}
                </v-tab>
                <v-tab>
                    <v-icon class="mr-1">mdi-lightbulb-outline</v-icon>
                    {{ $f.tc('listOfSuggestion') }}
                </v-tab>
                <v-tab v-if="allowCRM">
                    <v-icon class="mr-1">mdi-account</v-icon>
                    {{ $f.tc('crm') }}
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <VariableList></VariableList>
                </v-tab-item>
                <v-tab-item>
                    <ConstantList></ConstantList>
                </v-tab-item>
                <v-tab-item>
                    <TagList></TagList>
                </v-tab-item>
                <v-tab-item>
                    <WebViewList></WebViewList>
                </v-tab-item>
                <v-tab-item>
                    <SuggestionList></SuggestionList>
                </v-tab-item>
                <v-tab-item v-if="allowCRM">
                    <CRMList></CRMList>
                </v-tab-item>
            </v-tabs-items>
        </div>
    </FciDialog>
</template>

<script>
import DialogMixin from '@/modules/fptai/mixins/DialogMixin'
import FciDialog from '@/components/FciDialog'
import VariableList from '@/views/Scenario/Setting/VariableList'
import WebViewList from '@/views/Scenario/Setting/WebViewList'
import ConstantList from '@/views/Scenario/Setting/ConstantList'
import TagList from '@/views/Scenario/Setting/TagList'
import CRMList from '@/views/Scenario/Setting/CRMList'
import { mapState } from 'vuex'
import SuggestionList from '@/views/Scenario/Setting/SuggestionList'

export default {
    name: 'Setting',
    components: {
        SuggestionList,
        CRMList,
        TagList,
        ConstantList,
        WebViewList,
        VariableList,
        FciDialog
    },
    mixins: [DialogMixin],
    data () {
        return {
            tab: 0
        }
    },
    computed: {
        ...mapState({
            allowCRM: state => {
                for (let item of state.scenario.appConfigList) {
                    if (item.config_key === 'bot_allow_crm') {
                        return true
                    }
                }
                return false
            }
        })
    },
    methods: {
        open (tab = 0) {
            this.tab = tab
            this.show = true
        }
    }
}
</script>

<style scoped lang="scss">
.Setting {
    min-height: 700px;
}
</style>
